import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import SubscriptionSelect from 'shared/helpers/subscription-select'
import { propOr } from 'ramda'
import Select from 'react-select'
import { localizedTranslate } from 'assets/localization'
import { Position, Tooltip, Overlay } from '@blueprintjs/core'
import ProjectFilter from 'containers/scheduler/project-filter'
import { isPMOrAdmin } from 'shared/helpers/user'

const AccountSelection = (props) => {

  return (<div className='selections filter-toggles'>
    <div className="account-select">
      <Select
        value={props.selectedAccount}
        defaultMenuIsOpen={true}
        clearable={false}
        searchable={false}
        onChange={({ value }) => {
          props.selectAccount(value)
          props.selectClients({fromAccountUpdate: true})
          props.setAccountsSelected(true)
          props.updateAccountSelection(value)
          props.clientsSelected && props.fetchProjectsList({})
        }}
        options={props.allAccountsList.map(account => ({ value: account.id, label: account.value }))}
        valueRenderer={props.renderAccountValue}
        placeholder={
          <span className="place-holder">
            <i className='im-earth' />
          </span>
        }
        onOpen={() => {
          props.setShowAccountTooltip(false)
        }}
        onClose={() => {
          !props.accountsSelected && props.selectAccount(1)
          props.setAccountsSelected(true)
        }}
      />
    </div>
  </div>
  )
}

const ClientsSelection = (props) => {

  const [hidePlaceholer, setHidePlaceholder] = useState(false)

  return (<div className='selections filter-toggles'>
    <div className={`client-select ${props.className} ${!props.filteredClients.size? 'no-action' : '' }`}>
    <ProjectFilter
        collection={props.allClientsList.map(c => ({value: c.salesforce_account_id, label: c.name}))}
        filteredItems={props.filteredClients}
        collectionToFilter={'Clients'}
        icon={<div className='clients-dropdown-icon-container'><img
          className="clients-dropdown-icon"
          src="/images/briefcase.svg"
          role="presentation"
        /></div>}
        svgIcon={true}
        searchable={true}
        hidePlaceholer={hidePlaceholer}
        onClearAll={() => {
          props.selectClients()
          props.accountsSelected && props.fetchProjectsList({})
          props.accountsSelected && props.fetchInterviewsList()
        }}
        onOpen={() => {
          props.setShowClientTooltip(false)
          setHidePlaceholder(true)
        }}
        onClose={() => {
          props.setClientsSelected(true)
          setHidePlaceholder(false)
          props.accountsSelected && props.fetchProjectsList({})
          props.accountsSelected && props.fetchInterviewsList()
        }}
        onChange={newOption => {
          props.setClientsSelected(true)
          props.selectClients(newOption.value)
          props.accountsSelected && props.fetchProjectsList({})
          props.accountsSelected && props.fetchInterviewsList()
        }}
        filterSelected={true}
        selectAllDisabled={false}
        onSelectAll={() => {
          props.allClientsList.map(c => props.selectClients(c.salesforce_account_id))
          props.accountsSelected && props.fetchProjectsList({})
          props.accountsSelected && props.fetchInterviewsList()
        }}
      />
    </div>
  </div>
  )
}

const RenderValue = ({ icon, value }) =>
  <span className="place-holder">
    <i className={icon} />
    <label>{value}</label>
  </span>
class Topbar extends React.Component {
  state = {
      isInterviewPage : window.location.href.indexOf("interviews") > -1
  }

  componentDidMount() {
      if(!this.props.isFetchingUser) {
      isPMOrAdmin() && this.props.updateAccountSelection(this.props.selectedAccount)
      isPMOrAdmin() && this.props.accountsSelected && this.props.fetchProjectsList()
      this.state.isInterviewPage && this.props.accountsSelected && this.props.fetchInterviewsList()
    }
  }

  componentDidUpdate(prevProps) {
    const prevClients = [...prevProps.filteredClients]
    const newClients = [...this.props.filteredClients]
    if( prevClients.length !== newClients.length ) {
      isPMOrAdmin() && this.props.fetchProjectsList()
      this.state.isInterviewPage && this.props.fetchInterviewsList()
    }
  }

  navigateToProjects = () => {
    this.props.history.push('/projects')
  }

  navigateToNewProject = () => {
    this.props.history.push('/projects/creation')
  }

  navigateToCurrentProject = () => {
    this.props.history.push(`/projects/${this.props.currentProject.id}/dashboard`)
  }

  showModal = () => {
    const onResultsList = this.props.urlPath === '/projects/:projectId/results'
    const projectOrTimeslotUrl = onResultsList
      ? `${window.location.origin}/qual/preview/project/${this.props.shareHash}`
      : `${window.location.origin}/qual/preview/interview/${this.props.shareHash}`
    this.props.openModal({
      projectOrTimeslotUrl: projectOrTimeslotUrl,
      timeSlotId: this.props.timeSlotId,
      projectId: this.props.projectId,
    })
  }

  
  renderAccountValue = () =>
    <RenderValue
      icon={'im-earth'}
      value={this.props.allAccountsList.filter(ac => ac.id === this.props.selectedAccount)[0].value}
    />

  render() {
    const newProject = this.props.urlPath === '/projects/creation'
    const topLevel = this.props.urlPath === '/projects'
    const projectName = propOr('', 'name', this.props.currentProject)
    const onSchedule = this.props.urlPath === '/projects/:projectId/schedule'
    const onResults = this.props.urlPath.includes('/projects/:projectId/results')
    const title = this.props.title
    let isPM = isPMOrAdmin()
    const isProjectDashboard = window.location.href.indexOf("dashboard") > -1
    const isConferenceLinkPage = window.location.href.indexOf("conference-link/translations") > -1
    const conferenceLinkHeaderText = !this.props.currentProject.showCopyLinkButton ? this.props.t('add.conference.link.header') : this.props.t('edit.conference.link.header')
    const topicLinkHeaderText = window.location.href.indexOf("topic-name/translations") > -1 ?  '> ' + this.props.t('edit.topic.name.sub.header') : ''

 const addSubHeader = () => {
      if (isConferenceLinkPage) {
        return conferenceLinkHeaderText
      } else if (topicLinkHeaderText) {
        return topicLinkHeaderText
      } else {
        return ''
      }
    }
    return (
      <div className={"topbar" + (topLevel ? " project-page-responsive-topbar" : "")}>
        {topLevel && <div className="topbar-filler"></div>}
        <div className='title-selections'>
          <div className="user-management-header">
            <div className='topbar-header'>
              {topLevel || title === "Interviews" ? <div className={`topbar-title ${title === "Interviews" && !isPM ? 'interviews-title' : title}`}>{title}</div> : <div className='project-title'>{newProject ? "New Project" : projectName}</div>}
              {isProjectDashboard && <>  <div className='line dashboard'></div>
                <h6 className='sub-header'>{'Projects >'} {this.props.currentProject.topicNameDefault} {addSubHeader()}</h6> </>}
            </div>
          </div>
          {/* <SubscriptionSelect
            breadcrumbs={
              <span>
                <span
                  className={topLevel ? '' : 'clickable'}
                  onClick={topLevel ? undefined : this.navigateToProjects}
                >
                  Projects
                </span>
                <span
                  className={(onSchedule || onResults) ? 'clickable' : ''}
                  onClick={(onSchedule || onResults) ? this.navigateToCurrentProject : undefined}
                >
                  {!topLevel && (
                    newProject ?
                      ' > New Project'
                      :
                      ` > ${this.props.loadingNextProject ? 'Loading...' : projectName}`
                  )}
                </span>
                {onResults && ' > Results'}
                {onSchedule && ' > Schedule'}
              </span>
            }
          /> */}
          {console.log("props in topbar ", this.props)}
          {!this.props.isFetchingUser && isPM && (topLevel || title === "Interviews") && (!this.props.clientsSelected || !this.props.accountsSelected)? <Overlay className={"add-overlay"}
            isOpen={true}
          >
              <Tooltip popoverClassName={"select-account-tooltip"}
                content={!this.props.accountsSelected && this.props.showAccountTooltip ? this.props.t('select.account.tooltip') : ''}
                position={Position.BOTTOM}
                className={"select-account-tooltip-message"}
                isOpen={!this.props.accountsSelected}
                enforceFocus={false}
              >
                <AccountSelection {...this.props} renderAccountValue={this.renderAccountValue} />
              </Tooltip>

              <Tooltip popoverClassName={"select-client-tooltip"}
                content={!this.props.clientsSelected && this.props.showClientTooltip ? this.props.t('select.client.tooltip') : ''}
                position={Position.BOTTOM}
                className={`select-client-tooltip-message`}
                isOpen={!this.props.clientsSelected}
                enforceFocus={false}
              >
                <ClientsSelection {...this.props} />
              </Tooltip>
          </Overlay> : (topLevel || title === "Interviews") && !this.props.isFetchingUser && isPM && <div className={`project-filters-2 ${title}`}>
            <AccountSelection {...this.props} renderAccountValue={this.renderAccountValue} />
            <ClientsSelection {...this.props} className={'client-select-2'}/>
          </div>} 
          
          
        </div>
        {topLevel && (
          <div className="topbar-buttons">
            <button onClick={this.navigateToNewProject} className="btn new-project-button" data-testid="NEW_PROJECT_BUTTON">
              <i className="im-ss-plus" />New Project
            </button>
          </div>
        )}
        {onResults && (
          <div className="topbar-buttons">
            <button onClick={this.showModal} className="btn share-button">
              <i className="im-share2" />Share
            </button>
          </div>
        )}
      </div>
    )
  }
}

Topbar.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  urlPath: PropTypes.string,
  currentProject: PropTypes.shape({
    name: PropTypes.string,
  }),
}

const mapDispatch = {
  selectAccount: account => ({
    type: 'SELECT_ACCOUNT',
    payload: {
      account: account,
    },
  }),
  selectClients: payload => ({
    type: 'SELECT_CLIENT',
    payload
  }),
  setShowAccountTooltip: showAccountTooltip => ({
    type: 'SET_SHOW_ACCOUNT_TOOLTIP',
    payload: {
      showAccountTooltip: showAccountTooltip,
    },
  }),
  setAccountsSelected: accountsSelected => ({
    type: 'SET_ACCOUNTS_SELECTED',
    payload: {
      accountsSelected: accountsSelected,
    },
  }),
  setClientsSelected: clientsSelected => ({
    type: 'SET_CLIENTS_SELECTED',
    payload: {
      clientsSelected: clientsSelected,
    },
  }),
  setShowClientTooltip: showClientTooltip => ({
    type: 'SET_SHOW_CLIENTS_TOOLTIP',
    payload: {
      showClientTooltip: showClientTooltip,
    },
  }),
  fetchProjectsList: payload => ({ type: 'FETCH_PROJECTS_LIST_REQUESTED', payload}),
  updateAccountSelection: payload => ({ type: 'UPDATE_ACCOUNT_SELECTION', payload}),
  fetchInterviewsList: payload => ({type: 'FETCH_INTERVIEWS_LIST_REQUESTED', payload}),
}

function mapStateToProps(state) {
  return {
    currentProject: state.currentProject,
    selectedAccount: state.user.selectedAccount,
    showAccountTooltip: state.user.showAccountTooltip,
    filteredClients: state.user.filteredClients,
    showClientTooltip: state.user.showClientTooltip,
    allAccountsList: state.login.allAccountsList,
    accountsSelected: state.login.accountsSelected,
    allClientsList: state.login.allClientsList,
    clientsSelected: state.login.clientsSelected,
    t: localizedTranslate('en', state.translations.en_us),
    q: state.projectList.q,
    creatorId: state.projectList.creatorId,
    sortBy: state.projectList.sortBy,
    sortDir: state.projectList.sortDir,
    status: state.projectList.status,
    isFetchingUser: state.user.isFetching
  }
}


export default connect(mapStateToProps, mapDispatch)(Topbar)
